module.exports = "//cdn.livechat-static.com/webapp/img/automation/One-icon-default.png?d2760c1608758114d0f27f1478d3d9b2";